import { alias } from '@ember/object/computed';

import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  saveHasManyRelationships,
  updateUrlAliasParents,
} from 'umg-ember-backend/utils/model-save-hooks';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations();

export const settings = {
  saveHooks: {
    after: [updateUrlAliasParents, saveHasManyRelationships('urlAliases')],
  },
  variantProperties: [
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'keywords',
    'seoImage',
    'cmsState',
    'description',
    'headline',
  ],
};

export default class WebSeriesModel extends Model.extend(Validations) {
  @attr('string') catmamaId;
  @attr('string') description;
  @attr('string') headline;
  @attr('string') type;
  @attr('boolean') visibleInList;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('string') keywords;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('channel', { async: true, inverse: null }) channels;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @belongsTo('asset', { async: true, inverse: null }) cover;
  @hasMany('product-family', { async: true, inverse: null }) productFamilies;
  @hasMany('url-alias', { async: true, inverse: null }) urlAliases;

  // Getter, setter and computed properties
  @alias('headline') displayLabel;
}
